/* eslint-disable import/no-cycle */
import VueStore from '@/store';
import AuthLayout from '../layouts/AuthLayout.vue';

import LoginNew from '../views/Auth/LoginNew.vue';

import Welcome from '../views/Auth/Welcome.vue';

const ChangePassword = () => import('../views/ForgotPassword/ChangePassword.vue');
const NewPasswordRequest = () => import('../views/Auth/NewPasswordRequest.vue');
const ResetPasswordNew = () => import('../views/ForgotPassword/ResetPasswordNew.vue');

export default {
  path: '/logowanie',
  component: AuthLayout,
  children: [
    {
      path: '/',
      name: 'Auth.Login',
      component: LoginNew,
      meta: {
        unauthorized: true,
        background: 'blue-white',
      },
      beforeEnter: (to, from, next) => {
        if (VueStore.getters['auth/isLogged']) {
          next({ name: 'Auth.Welcome' });
        } else {
          next();
        }
      },
    },
    {
      path: 'login-from-office',
      name: 'Auth.OfficeLogin',
      beforeEnter: async (to, from, next) => {
        next(await VueStore.dispatch('auth/officeLogin'));
      },
      meta: {
        unauthorized: true,
      },
    },
    {
      path: 'ustaw-haslo/:token',
      name: 'Auth.FirstLogin',
      component: ResetPasswordNew,
      meta: {
        unauthorized: true,
        background: 'white',
      },
    },
    {
      path: 'zresetuj-haslo',
      name: 'Auth.NewPasswordRequest',
      component: NewPasswordRequest,
      props: true,
      meta: {
        unauthorized: true,
        background: 'blue-light-main',
      },
    },
    {
      path: 'wybierz-dziecko',
      name: 'Auth.Welcome',
      component: Welcome,
      meta: {
        background: 'blue-light-main',
      },
      beforeEnter: (to, from, next) => {
        if (VueStore.getters['auth/isLogged']) {
          next();
        } else {
          next({ name: 'Auth.Login' });
        }
      },
    },
    {
      path: 'zmien-haslo',
      name: 'Auth.ChangePassword',
      component: ChangePassword,
      meta: {
        background: 'blue-light-main',
      },
      beforeEnter: (to, from, next) => {
        if (VueStore.getters['auth/isLogged']) {
          next();
        } else {
          next({ name: 'Auth.Login' });
        }
      },
    },
  ],
};
